import React from 'react';
import WeekPickerNav from '../WeekPickerNav';
import { useSiteContext } from '../../SiteContext';
import { useSelectPayPeriod } from '../../hooks/useSelectPayPeriod';

/**
 * Global header week control. Wraps WeekPickerNav (index-based over payPeriods) and
 * writes the selected pay period through to SiteContext so every page — v2 and hosted
 * legacy — stays on the same week. The index is ALWAYS resolved from payPeriodID,
 * never derived from WeekNumber.
 */
const GlobalWeekPill: React.FC = () => {
  const { payPeriods, payPeriodID } = useSiteContext();
  const selectPayPeriod = useSelectPayPeriod();

  const selectedIdx = payPeriods.findIndex((pp) => pp.PayPeriodID === payPeriodID);

  // Nothing to render until pay periods have loaded and a period is selected.
  if (payPeriods.length === 0 || selectedIdx === -1) return null;

  const handleChange = (idx: number) => {
    const pp = payPeriods[idx];
    if (pp) selectPayPeriod(pp);
  };

  return (
    <WeekPickerNav payPeriods={payPeriods} selectedIdx={selectedIdx} onChange={handleChange} />
  );
};

export default GlobalWeekPill;
